/* @ngInject */

export default (
  $state,
  $rootScope,
  $window,
  $filter,
  authenticationService,
  logger,
  cookies,
  NAVIGATION
) => {
  var service = {
    goTo: goTo,
    goToCurrentState: goToCurrentState,
    goToLastWorkflow: goToLastWorkflow,
    goToPreviousState: goToPreviousState,
    organizationChange: organizationChange,
    persist: persist,
    isBrowserSupported: isBrowserSupported
  };
  return service;

  /**
   * Checking if the browser is supported
   */
  function isBrowserSupported() {
    // Opera 8.0+
    // var isOpera =
    //   (!!window.opr && !!opr.addons) ||
    //   !!window.opera ||
    //   navigator.userAgent.indexOf(' OPR/') >= 0;
    // Firefox 1.0+
    // var isFirefox = typeof InstallTrigger !== 'undefined';
    // Safari 3.0+ "[object HTMLElementConstructor]"
    // var isSafari =
    //   /constructor/i.test(window.HTMLElement) ||
    //   (function(p) {
    //     return p.toString() === '[object SafariRemoteNotification]';
    //   })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/ false || !!document.documentMode;
    // Edge 20+
    // var isEdge = !isIE && !!window.StyleMedia;
    // Chrome 1 - 71
    // var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    return !isIE;
  }

  /**
   * Navigates to state with supplied parameters.
   *
   * @param {Object} $event
   * @param {Object} toState
   */
  function goTo($event, toState) {
    logger.log('navigationService', 'goTo', toState.name);
    if (!authenticationService.isAuthenticated() && toState.name !== 'authenticate') {
      $event.preventDefault();
      $state.transitionTo('authenticate');
      return;
    }
    if (
      authenticationService.isSuspended() &&
      toState.name !== 'settings.plan-and-billing' &&
      toState.name !== 'authenticate' &&
      toState.name !== 'organizationSuspended' &&
      toState.name !== 'settings.users' &&
      $rootScope.CurrentOrganization.idOwner === $rootScope.CurrentAccount.id
    ) {
      $event.preventDefault();
      $state.transitionTo('settings.plan-and-billing');
      return;
    } else if (
      authenticationService.isSuspended() &&
      toState.name !== 'settings.plan-and-billing' &&
      toState.name !== 'authenticate' &&
      toState.name !== 'organizationSuspended' &&
      $rootScope.CurrentOrganization.idOwner !== $rootScope.CurrentAccount.id
    ) {
      $event.preventDefault();
      $state.transitionTo('organizationSuspended');
      return;
    }
    if (
      authenticationService.isAuthenticated() &&
      !authenticationService.isSuspended() &&
      !authenticationService.isOnboarded()
    ) {
      if (
        toState.name !== 'settings.my-account' &&
        toState.name !== 'authenticate' &&
        toState.name !== 'organizationSwitch' &&
        !$rootScope.CurrentAccount.hasAccountDetails()
      ) {
        $event.preventDefault();
        $state.transitionTo('settings.my-account');
        return;
      } else if (
        toState.name !== 'settings.my-account' &&
        toState.name !== 'settings.my-accreditations' &&
        toState.name !== 'settings.my-personalization' &&
        toState.name !== 'settings.updates-and-reminders' &&
        toState.name !== 'settings.password-and-security' &&
        toState.name !== 'authenticate' &&
        toState.name !== 'organizationSwitch' &&
        $rootScope.CurrentAccount.hasAccountDetails()
      ) {
        $event.preventDefault();
        $state.transitionTo('settings.my-account');
        return;
      }
    }
    if (
      authenticationService.isAuthenticated() &&
      !authenticationService.isSuspended() &&
      authenticationService.isOnboarded() &&
      authenticationService.isPasswordChangeRequired() &&
      toState.name !== 'settings.password-and-security' &&
      toState.name !== 'authenticate' &&
      toState.name !== 'organizationSwitch'
    ) {
      $event.preventDefault();
      $state.transitionTo('settings.password-and-security');
      return;
    }
  }

  /**
   * Navigates to current state.
   */
  function goToCurrentState() {
    logger.log('navigationService', 'goToCurrentState');
    if (
      $rootScope.CurrentAccount &&
      $rootScope.CurrentAccount.userInterface &&
      $rootScope.CurrentAccount.userInterface.openDashboardOnLogin === true
    ) {
      $state.transitionTo('dashboard');
    } else {
      if (
        cookies.get(
          NAVIGATION.COOKIE.CURRENT_STATE +
            btoa($rootScope.CurrentOrganization.id) +
            btoa($rootScope.CurrentAccount.id)
        ) &&
        cookies.get(
          NAVIGATION.COOKIE.CURRENT_STATE +
            btoa($rootScope.CurrentOrganization.id) +
            btoa($rootScope.CurrentAccount.id)
        ) !== undefined
      ) {
        var currentState = JSON.parse(
          cookies.get(
            NAVIGATION.COOKIE.CURRENT_STATE +
              btoa($rootScope.CurrentOrganization.id) +
              btoa($rootScope.CurrentAccount.id)
          )
        );
        if (currentState.s && currentState.p) {
          $state.transitionTo(currentState.s, currentState.p);
          return;
        }
      }
      $state.transitionTo('home');
    }
  }

  /**
   * Navigates to last visited workflow, or first available.
   */
  function goToLastWorkflow(_workflows) {
    logger.log('navigationService', 'goToLastWorkflow');
    if (
      !_workflows ||
      !_workflows.length ||
      ($rootScope.CurrentAccount &&
        $rootScope.CurrentAccount.userInterface &&
        $rootScope.CurrentAccount.userInterface.openDashboardOnLogin === true)
    ) {
      $state.transitionTo('dashboard');
    } else {
      if (
        cookies.get(
          NAVIGATION.COOKIE.LAST_WORKFLOW +
            btoa($rootScope.CurrentOrganization.id) +
            btoa($rootScope.CurrentAccount.id)
        ) &&
        cookies.get(
          NAVIGATION.COOKIE.LAST_WORKFLOW +
            btoa($rootScope.CurrentOrganization.id) +
            btoa($rootScope.CurrentAccount.id)
        ) !== undefined
      ) {
        var lastWorkflowValue = JSON.parse(
          cookies.get(
            NAVIGATION.COOKIE.LAST_WORKFLOW +
              btoa($rootScope.CurrentOrganization.id) +
              btoa($rootScope.CurrentAccount.id)
          )
        );
        var lastWorkflow = $filter('filter')(_workflows, { id: lastWorkflowValue.w })[0];
        if (lastWorkflow && lastWorkflow.id) {
          $state.transitionTo('board', {
            id: lastWorkflow.id
          });
          return;
        }
      }
      $state.transitionTo('board', {
        id: _workflows[0].id
      });
    }
  }

  /**
   * Navigates to previous state.
   */
  function goToPreviousState() {
    logger.log('navigationService', 'goToPreviousState');
    if (
      cookies.get(
        NAVIGATION.COOKIE.PREVIOUS_STATE +
          btoa($rootScope.CurrentOrganization.id) +
          btoa($rootScope.CurrentAccount.id)
      ) &&
      cookies.get(
        NAVIGATION.COOKIE.PREVIOUS_STATE +
          btoa($rootScope.CurrentOrganization.id) +
          btoa($rootScope.CurrentAccount.id)
      ) !== undefined
    ) {
      var previousState = JSON.parse(
        cookies.get(
          NAVIGATION.COOKIE.PREVIOUS_STATE +
            btoa($rootScope.CurrentOrganization.id) +
            btoa($rootScope.CurrentAccount.id)
        )
      );
      if (previousState.s && previousState.p) {
        $state.transitionTo(previousState.s, previousState.p);
      }
    }
  }

  /**
   * Change active organization, or simply refresh authentication token.
   *
   * @param {Object} [_params]
   * @param {String} [_params.idOrganization] - Organization ID to use for token.
   * @param {String} [_params.url] - URL to load after successful token refresh.
   */
  function organizationChange(_params) {
    logger.log('navigationService', 'organizationChange');
    return authenticationService.organizationChange(_params).then(function (status) {
      if (_params.url && status) {
        $window.location.href = _params.url ? _params.url : '/';
      }
    });
  }

  /**
   * Persists state information.
   *
   * @param {Object} toState
   * @param {Object} toParams
   * @param {Object} fromState
   * @param {Object} fromParams
   */
  function persist(toState, toParams, fromState, fromParams) {
    logger.log('navigationService', 'persist');
    if (authenticationService.isAuthenticated() && toState.name !== 'authenticate') {
      if (toState && toState.name) {
        if (toState.name === 'board' || toState.name === 'project') {
          cookies.set(
            NAVIGATION.COOKIE.LAST_WORKFLOW +
              btoa($rootScope.CurrentOrganization.id) +
              btoa($rootScope.CurrentAccount.id),
            JSON.stringify({ w: toParams.id }),
            NAVIGATION.COOKIE.CONFIG
          );
        }
        if (toState.name !== 'organizationSwitch' && toState.name !== 'organizationSuspended') {
          cookies.set(
            NAVIGATION.COOKIE.CURRENT_STATE +
              btoa($rootScope.CurrentOrganization.id) +
              btoa($rootScope.CurrentAccount.id),
            JSON.stringify({ s: toState.name, p: toParams }),
            NAVIGATION.COOKIE.CONFIG
          );
        }
      }
      if (fromState && fromState.name) {
        if (toState.name !== 'organizationSwitch' && toState.name !== 'organizationSuspended') {
          cookies.set(
            NAVIGATION.COOKIE.PREVIOUS_STATE +
              btoa($rootScope.CurrentOrganization.id) +
              btoa($rootScope.CurrentAccount.id),
            JSON.stringify({ s: fromState.name, p: fromParams }),
            NAVIGATION.COOKIE.CONFIG
          );
        }
      }
    }
  }
};
